export default {
    feedbackMode: {
        backgroundColor: {
            ok: '#0663', // '#EAEAE7', // #eff "rgb(234, 234, 231)",
            notOk: '#c093', //'#F9E2F1', // #fef "rgb(249, 226, 241)"
        },
        xbackgroundColor: {
            ok: '#EAEAE7', // #eff "rgb(234, 234, 231)",
            notOk: '#F9E2F1', // #fef "rgb(249, 226, 241)"
        },
        borderColor: {
            ok: '#0666',
            notOk: '#c096'
        },
    },
    solutionMode:{
        on: '#eeee',
        off: 'transparent',
    },
    blau_in_den_Ueberschriften_links: '#086ca3', // bereits in Plone definiert
    maus_ueber_die_Ueberschrift: '#6d8e9d',

};

// in plone css
// .portletNavigationTree .portletContent > ul > li a:hover { color: #6d8e9d;}
